// src/components/news/NewsEvent.jsx

import React, { useState, useEffect } from "react";
import axios from "axios";
import "./News.css";
import Hrline from "../Hrline";
import NewsDetails from "./NewsDetail"; // ✅ Import Detail Component

const API_URL = process.env.REACT_APP_API_URL;

const NewsEvent = () => {
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedNewsId, setSelectedNewsId] = useState(null); // ✅ Store selected news ID

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get(`${API_URL}/news`);
        const normalizedData = response.data.map((news) => ({
          ...news,
          image: news.image.replace(/\\/g, "/"),
        }));
        const sortedData = normalizedData.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setNewsList(sortedData);
      } catch (error) {
        console.error("Error fetching news articles:", error.message);
        alert("Failed to fetch news articles. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  // ✅ Return back to list view
  const handleBack = () => {
    setSelectedNewsId(null);
  };

  // ✅ If a news is selected, show details view
  if (selectedNewsId !== null) {
    return (
      <NewsDetails
        id={selectedNewsId}
        newsList={newsList}
        onBack={handleBack}
        setId={setSelectedNewsId}
      />
    );
  }

  return (
    <section className={`news-section ${loading ? "blur-background" : ""}`}>
      <Hrline />
      {loading ? (
        <div className="news-loading-wrapper">
          <div className="news-loader">
            <span className="loader-box"></span>
            <span className="loader-box"></span>
            <span className="loader-box"></span>
            <span className="loader-box"></span>
          </div>
        </div>
      ) : (
        <div className="container py-5">
          <div className="row g-4">
            {newsList.length > 0 ? (
              newsList.map((news) => (
                <div className="col-md-4 col-sm-6" key={news.id}>
                  <article
                    className="cardss news-card h-100"
                    onClick={() => setSelectedNewsId(news.id)} // ✅ Replace navigation
                    role="button"
                  >
                    {news.image && (
                      <div className="news-card-img-wrapper">
                        <img
                          src={`${API_URL}${news.image}`}
                          alt={news.title}
                          className="news-card-img"
                        />
                      </div>
                    )}
                    <div className="news-card-body">
                      <p className="news-card-date">
                        {new Date(news.date).toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        })}
                      </p>
                      <h6 className="news-card-title">{news.title}</h6>
                    </div>
                  </article>
                </div>
              ))
            ) : (
              <p className="text-center">No news articles available.</p>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default NewsEvent;
